import { IncomingMessage, ServerResponse } from 'http'

import { getCookie } from 'cookies-next'

export const clientGetToggleFromCookie = (toggle: string): boolean => {
	const toggleCookie = getCookie('toggles') as string
	return toggleCookie && JSON.parse(toggleCookie).includes(toggle)
}

export const getToggleFromCookie = (
	toggle: string,
	req: IncomingMessage,
	res: ServerResponse
): boolean => {
	const toggleCookie = getCookie('toggles', { req, res }) as string

	// double bang to ensure the result is a boolean even if the cookie is not set
	return !!(toggleCookie && JSON.parse(toggleCookie).includes(toggle))
}

export default clientGetToggleFromCookie
